var React = require('react');

function WhiteArrowLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Line 9 Copy 2"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"square","key":1},React.createElement("polyline",{"id":"Line-9-Copy-2","stroke":"#FFFFFF","strokeWidth":"3","transform":"translate(8.000000, 13.000000) rotate(-180.000000) translate(-8.000000, -13.000000) ","points":"3 23 13 13 3 3"}))]);
}

WhiteArrowLeft.defaultProps = {"width":"16px","height":"26px","viewBox":"0 0 16 26","version":"1.1"};

module.exports = WhiteArrowLeft;

WhiteArrowLeft.default = WhiteArrowLeft;
